import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const items = [
    { key: "faq", label: "자주 찾는 질문", to: "/help/faq" },
    { key: "help", label: "1:1 문의", to: "/help" },
    { key: "inquiry", label: "1:1 문의 조회", to: "/help/inquiry" },
    { key: "notice", label: "공지사항", to: "/help/notice" },
];

const HelpAside = ({ activeKey, className = "", showTitle = true }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const current = useMemo(() => {
        if (activeKey) return activeKey;
        if (pathname.startsWith("/help/faq")) return "faq";
        if (pathname.startsWith("/help/inquiry")) return "inquiry";
        if (pathname.startsWith("/help/notice")) return "notice";
        return "help";
    }, [activeKey, pathname]);

    return (
        <aside className={`col-span-12 lg:col-span-3 ${className}`}>
            {showTitle && (
                <div className="pb-3 pl-4">
                    <h2 className="text-3xl font-extrabold text-gray-900">고객센터</h2>
                </div>
            )}
            <div className="rounded-2xl border p-2">
                {items.map((it) => {
                    const isActive = current === it.key;
                    return (
                        <button
                            key={it.key}
                            className={`w-full flex items-center justify-between px-4 py-3 rounded-xl ${
                                isActive
                                    ? "bg-violet-50 text-violet-600 font-semibold"
                                    : "hover:bg-gray-50 text-gray-700"
                            }`}
                            onClick={() => {
                                if (pathname === it.to) {
                                    // 같은 경로를 다시 클릭하면 페이지 새로고침
                                    navigate(0);
                                } else {
                                    navigate(it.to);
                                }
                            }}
                            type="button"
                        >
                            <span>{it.label}</span>
                            <span className={isActive ? "text-violet-300" : "text-gray-300"}>›</span>
                        </button>
                    );
                })}
            </div>
        </aside>
    );
};

export default HelpAside;
